<template>
	<div>
		<div
			class="modal fade modal-fullscreen-mobile"
			ref="modal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			data-focus="false"
		>
			<div class="modal-dialog vld-parent" role="document">
				<div class="modal-content">
					<div
						class="modal-header modal-header-banner"
						:style="eventBannerStyle"
					>
						<button
							type="button"
							class="modal-close"
							@click="close"
							aria-label="Close"
						>
							<i class="sk-icon-times"></i>
						</button>
						<h1 class="modal-title">{{ title }}</h1>
					</div>
					<div class="modal-body">
						<loading :active="loading" />
						<div class="modal-inner-content">
							<h2 class="modal-subtitle">
								{{ subtitle }}
							</h2>
							<div class="step-container">
								<div
									class="step sk-widget"
									v-for="(step, index) in steps"
									:key="index"
								>
									<div>
										<img
											:src="step.imageUrl"
											:alt="`Step ${index}`"
										/>
									</div>
									<div>
										<div class="step-title">
											{{ step.title }}
										</div>
										<div class="step-description">
											{{ step.description }}
										</div>
									</div>
								</div>
							</div>
							<button
								class="button button-primary"
								@click="viewMenuClicked"
							>
								{{ ctaText }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-header-banner {
	height: 133px;
}

.modal-body {
	justify-content: flex-start;
	padding: 0 10px 20px 10px;
}

.modal-title {
	font-size: 18px;
	text-align: center;
	margin: 0 10px;
	margin-left: 10px !important;
	width: 100%;
	background: var(--gR-base-80);
	color: var(--gR-white);
	align-self: flex-end;
	line-height: 45px;
	border-top-right-radius: 5px;
	border-top-left-radius: 5px;
}

.modal-subtitle {
	font-size: 14px;
	color: var(--sk-grey3);
	text-align: center;
	margin: 0;
	border: 1px solid var(--gR-white2);
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
	padding: 20px;
}

.modal-inner-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
}

.modal-inner-content .button {
	flex-shrink: 0;
}

.step-container {
	margin: 15px 0 0 0;
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
}

.step {
	display: flex;
	align-items: center;
}

.step img {
	width: 75px;
	height: 75px;
}

.step-title {
	font-size: 14px;
	font-weight: 600;
	color: var(--gR-base-80);
	margin-bottom: 10px;
}

.step-description {
	font-size: 12px;
	color: var(--sk-grey3);
}

@media (max-width: 400px) and (max-height: 600px) {
	.modal-subtitle {
		font-size: 12px;
	}

	.step-container {
		margin: 10px 0 0 0;
	}

	.sk-widget.step {
		margin-bottom: 10px;
	}

	.step-title {
		font-size: 12px;
		margin-bottom: 0;
	}

	.step-description {
		font-size: 10px;
	}
}
</style>

<script>
import { BusinessEventType } from "@reef-os/utils/enums/businessEventType"
import moment from "moment"
import eventDetailsMixin from "@/mixins/event-details-mixin"
import Loading from "vue-loading-overlay"

export default {
	name: "UpcomingEventModal",
	mixins: [eventDetailsMixin],
	components: {
		Loading
	},
	data: function () {
		return {
			eventId: 0
		}
	},
	computed: {
		loading() {
			return (
				this.title.length <= 0 ||
				this.subtitle.length <= 0 ||
				this.steps.length <= 0
			)
		},
		event() {
			if (this.eventId && this.$store.state.businessEvents) {
				return this.$store.state.businessEvents.find(
					(menu) => menu.id == this.eventId
				)
			}
			return null
		},
		eventWeekday() {
			if (this.event) {
				switch (this.event.type) {
					case BusinessEventType.POPUP:
						return moment(
							this.event.start_date,
							"YYYY-MM-DD"
						).format("dddd")
					case BusinessEventType.VIRTUAL:
						return moment(this.event.end_date, "YYYY-MM-DD").format(
							"dddd"
						)
				}
			}
			return ""
		},
		cutoffDay() {
			if (this.event) {
				return moment(
					this.event.pre_order_end_date,
					"YYYY-MM-DD"
				).format("dddd")
			}
			return ""
		},
		cutoffDate() {
			if (this.event) {
				return moment(
					this.event.pre_order_end_date,
					"YYYY-MM-DD"
				).format("MMMM Do")
			}
			return ""
		},
		cutoffTime() {
			if (this.event) {
				return moment(this.event.pre_order_end_time, "HH:mm:ss").format(
					"h:mm a"
				)
			}
			return ""
		},
		deliveryDate() {
			if (this.event) {
				switch (this.event.type) {
					case BusinessEventType.POPUP:
						return moment(
							this.event.start_date,
							"YYYY-MM-DD"
						).format("MMMM Do")
					case BusinessEventType.VIRTUAL:
						return moment(this.event.end_date, "YYYY-MM-DD").format(
							"MMMM Do"
						)
				}
			}
			return ""
		},
		deliveryTime() {
			if (this.event) {
				switch (this.event.type) {
					case BusinessEventType.POPUP:
						return moment(this.event.start_time, "HH:mm:ss").format(
							"h:mm a"
						)
					case BusinessEventType.VIRTUAL:
						return moment(this.event.end_time, "HH:mm:ss").format(
							"h:mm a"
						)
				}
			}
			return ""
		},
		eventRestaurant() {
			if (this.event) {
				const restaurantId = this.event.restaurant_id
				return this.$store.state.restaurants[restaurantId]
			}
			return null
		},
		businessName() {
			return this.$store.state.business
				? this.$store.state.business.name
				: ""
		},
		title() {
			if (this.event) {
				switch (this.event.type) {
					case BusinessEventType.POPUP:
						return `${this.businessName} Popup!`
					case BusinessEventType.VIRTUAL:
						return this.eventName
				}
			}
			return ""
		},
		subtitle() {
			if (this.event) {
				switch (this.event.type) {
					case BusinessEventType.POPUP:
						if (
							this.eventRestaurant &&
							this.eventWeekday &&
							this.deliveryTime &&
							this.businessName
						) {
							return `${this.eventRestaurant.name} is stopping by ${this.businessName} for a one-night-only popup! Quantities are limited, so place your pre-order now to guarantee your meal.`
						}
						break
					case BusinessEventType.VIRTUAL:
						if (
							this.eventRestaurant &&
							this.eventWeekday &&
							this.deliveryTime &&
							this.businessName
						) {
							return `${this.eventRestaurant.name} is stopping by ${this.businessName} for a virtual popup! Pre-order your meal and have it delivered to the lobby on ${this.eventWeekday} at ${this.deliveryTime}.`
						}
						break
				}
			}
			return ""
		},
		steps() {
			if (this.event) {
				switch (this.event.type) {
					case BusinessEventType.POPUP: {
						if (
							this.eventWeekday &&
							this.deliveryDate &&
							this.deliveryTime &&
							this.eventRestaurant
						) {
							return [
								{
									title: "Save the Date",
									description: `${this.eventRestaurant.name} will be doing an exclusive popup on ${this.eventWeekday} ${this.deliveryDate} at ${this.deliveryTime}`,
									imageUrl: "/images/2k-calendar.png"
								},
								{
									title: "Priority Pre-Ordering",
									description:
										"Quantities are limited. Guarantee your first-choice is in stock by pre-ordering.",
									imageUrl: "/images/2k-card-pay.png"
								},
								{
									title: "Fast & Easy Pickup",
									description: `With pre-orders, residents skip the popup’s line and pickup their order starting at ${this.deliveryTime}`,
									imageUrl: "/images/2k-out-of-stock.png"
								}
							]
						}
						break
					}
					case BusinessEventType.VIRTUAL: {
						if (
							this.eventWeekday &&
							this.deliveryDate &&
							this.deliveryTime &&
							this.eventRestaurant
						) {
							let preorderDescription = ""
							if (
								this.event.end_date ==
									this.event.pre_order_end_date &&
								this.event.pre_order_end_time == "00:00:00"
							) {
								preorderDescription =
									"Due to expected high demand, orders are available on a pre-order basis until the day of the event"
							} else {
								preorderDescription = `Due to expected high demand, orders are available on a pre-order basis until ${this.cutoffDay} ${this.cutoffDate} at ${this.cutoffTime}`
							}
							return [
								{
									title: "1 Save the Date",
									description: `${this.eventRestaurant.name} will be doing an exclusive virtual popup on ${this.eventWeekday} ${this.deliveryDate} at ${this.deliveryTime}`,
									imageUrl: "/images/2k-calendar.png"
								},
								{
									title: "2 Pre-Order Only",
									description: preorderDescription,
									imageUrl: "/images/2k-card-pay.png"
								},
								{
									title: "3 Enjoy",
									description: `All orders will be delivered to the building lobby at ${this.deliveryTime} on ${this.deliveryDate}`,
									imageUrl: "/images/2k-out-of-stock.png"
								}
							]
						}
						break
					}
				}
			}
			return []
		},
		ctaText() {
			if (this.event) {
				switch (this.event.type) {
					case BusinessEventType.POPUP:
						return "View Menu"
					case BusinessEventType.VIRTUAL:
						return "Explore Menu"
				}
			}
			return ""
		}
	},
	methods: {
		open(options) {
			let isModalOpen = $(this.$refs.modal).is(":visible")
			if (isModalOpen) {
				return
			}
			this.eventId = options.eventId
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Upcoming Event Modal CTA Opened",
				data: {
					eventId: this.eventId
				}
			})
			this.$store.dispatch("markFlag", {
				flag: "displayedUpcomingModal",
				value: true
			})
			$(this.$refs.modal).modal("show")
		},
		viewMenuClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Upcoming Event Modal CTA Clicked",
				data: {
					eventId: this.eventId
				}
			})

			this.$router.push({
				path: `/${this.$route.params.slug}/menu/event/${this.eventId}`
			})

			this.close()
		},
		close() {
			$(this.$refs.modal).modal("hide")
		}
	}
}
</script>
